<ng-template [ngTemplateOutlet]="content"></ng-template>
<ng-template #content>
    <ng-content></ng-content>
</ng-template>